/**
 * WCAG 3.1.1 (Phase 4 G1 / WCAG-B-03) — langue du document pour lecteurs d’écran.
 * `index.html` déclare déjà `lang="fr"` ; cette fonction sécurise les shells
 * qui remplacent le DOM ou les documents créés sans attribut.
 */
export function ensureDocumentLang(lang: string = 'fr'): void {
  if (typeof document === 'undefined') return;
  const html = document.documentElement;
  if (!html) return;
  const current = (html.getAttribute('lang') ?? '').trim();
  if (!current) {
    html.setAttribute('lang', lang);
    return;
  }
  // Normaliser « fr-FR » / espaces — conserver une variante fr si déjà présente.
  if (!current.toLowerCase().startsWith('fr')) {
    html.setAttribute('lang', lang);
  }
}
